export const environment = {
  frontendURL: 'https://dev.projekt-planer.des.de',
  allowedDomains: ['dev.projekt-planer.des.de', 'graph.microsoft.com']
};
